import { DataModel } from "common/models/utility-models/base-model";

export class MentorMappingListModel extends DataModel {
  
    mentorName: string = null;
    mentorEmail: string = null;
    mentorContact: string =  null;
    mentorStateId: string = null;
    mentorGender: string = null;
    mentorCompany: string = null;
    is_delete:string ="0";
    created: string = null;
    modified: string = null;
}

export class MentorMappingModel extends DataModel {
    mentorId: number = null;
    batch_id: number = null;
    group_id: number = null;
    branch_id: number = null;
    // east: boolean = null;
    // west: boolean = null;
    // north: boolean = null;
    // south: boolean = null;
    student_ids: any[] = [];
}

export class MentorPost
{
    mentorId:'';
    student_ids:[];
}